module.exports = __webpack_public_path__ + "img/restaurant.870e7f73.jpg";